import ContactListsListingTable from "../contacts/ContactListsListingTable";
import { useCampaignStore } from "../../../../../stores/CampaignStore";
import { Box, Group, Stack, Text } from "@mantine/core";
import AnalysisWidget from "./StepAudienceAnalysis";

const StepAudience = ({ setActive }) => {
  const programData = useCampaignStore((s) => s.programData);
  const setProgramData = useCampaignStore((s) => s.setProgramData);

  const handleSelectionChange = (selectionModel) => {
    setProgramData({
      ...programData,
      contactlist_ids: selectionModel,
    });
  };

  return (
    <Box mx="auto" p="xl" pos={"relative"} miw={"100%"}>
      {/* HEADER */}
      <Stack gap={4} mb="xl">
        <Text c="violet.5" fw={600} size="md">
          Étape 2 · Votre audience
        </Text>
        <Text component="h1" size="xl" fw={700} m={0} style={{ fontSize: 24 }}>
          Qui votre agent doit-il contacter ?
        </Text>
        <Text c="dimmed" size="sm">
          Sélectionnez une liste de contacts. Votre agent l’analyse
          automatiquement pour personnaliser chaque message.
        </Text>
      </Stack>

      {/* FOOTER / CONTINUER */}
      <Group mt="xl" align="start" gap={"xl"}>
        <Stack w={"70%"}>
          <ContactListsListingTable
            selectionModel={programData?.contactlist_ids}
            onSelectionChange={handleSelectionChange}
            isAudience
          />
        </Stack>
        <AnalysisWidget
          lists={programData?.contactlist_ids}
          setActive={setActive}
        />
      </Group>
    </Box>
  );
};

export default StepAudience;
